import { useEffect } from "react";

const ProtectPage = () => {
  useEffect(() => {
    const disableRightClick = (event) => event.preventDefault();
    const disableInspect = (event) => {
      if (event.ctrlKey && (event.key === "u" || event.key === "U")) {
        event.preventDefault();
      }
    };

    document.addEventListener("contextmenu", disableRightClick);
    document.addEventListener("keydown", disableInspect);

    return () => {
      document.removeEventListener("contextmenu", disableRightClick);
      document.removeEventListener("keydown", disableInspect);
    };
  }, []);

  return null;
};

export default ProtectPage;
